// extracted by mini-css-extract-plugin
export var darkMode = "_8-0";